import React from 'react';

import { Footer } from '../Footer/Footer';
import { Navbar } from '../Navbar/Navbar';
import { Sidebar } from '../Sidebar/Sidebar';

import styles from './Layout.module.scss';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => (
  <div className={styles.wrapper}>
    <Navbar />
    <div className={styles.content}>
      <Sidebar />
      <main className={styles.main}>{children}</main>
    </div>
    <Footer />
  </div>
);
